import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import HouseKeepingRoutes from './base/main_routes';

function App() {
  return (
    <Router>
      <HouseKeepingRoutes />
    </Router>
  );
}

export default App;
